

<div class="container d-flex flex-column flex-lg-row-reverse gap-5 my-5 px-3 chat-box">



    <!-- ticket info -->
    <div class="list-group w-100 info-box">

        <div href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3 tag-1 bg-gradient justify-content-end" aria-current="true">

            <div>
                <h6 class="mb-0 text-white fs-5 ">معلومات الطلب</h6>
            </div>

        </div>

        <div href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">

            <div>
                <h6 class="mb-0 fs-6 text-end">رقم الطلب</h6>
                <p class="mb-0 opacity-75 fs-6 text-end mt-2 text-truncate sub-header">{{ full_chat_data?.id }}</p>
            </div>

        </div>

        <div href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">

            <div>
                <h6 class="mb-0 fs-6 text-end">موضوع الطلب</h6>
                <p class="mb-0 opacity-75 fs-6 text-end mt-2 text-truncate sub-header">{{ full_chat_data?.title }}</p>
            </div>

        </div>

        <div href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">

            <div>
                <h6 class="mb-0 fs-6 text-end">حالة الطلب</h6>
                <p class="mb-0 opacity-75 fs-6 text-end mt-2 text-truncate sub-header">{{ full_chat_data?.ticketStatus }}</p>
            </div>

        </div>


        <div href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">

            <div>
                <h6 class="mb-0 fs-6 text-end">تاريخ التذكرة</h6>
                <p class="mb-0 opacity-75 fs-6 text-end mt-2 text-truncate sub-header">{{ full_chat_data?.created | date_to_local }}</p>
            </div>

        </div>


    </div>


    <!-- chat -->
    <div class="d-flex flex-column w-100">

        <div class="card text-white mb-3" style="max-width: 18rem;" *ngFor="let chat of conversation" 
        [ngClass]="{ 'me-auto' : chat?.reply_type_id == 0 , 'bg-warning' : chat?.reply_type_id == 1 , 'bg-danger' : chat?.reply_type_id == 0 }">
            
            <div class="align-items-center justify-content-between card-header d-flex">

                <div class="d-flex gap-3 align-items-center">
                    <img src="../../assets/icons/user.png" alt="user icon" width="40" height="40">
                    <h1 class="m-0">{{ chat?.reply_type_id == 1 ? 'أنا' : 'كودز روتس' }}</h1>      
                </div>

  
                <span class="text-muted m-0">{{ chat?.created | date_to_local }}</span>
                

            </div>
    
            <div class="card-body">
              <p class="card-text text-end">{{ chat?.message }}</p>
            </div>
        
        </div>
    
    </div>

    


</div>


<div class="container text-chat-box">
    
    <div class="d-flex flex-row-reverse gap-lg-3">
        <div class="w-75 px-2 px-lg-4">
            <textarea class="form-control text-chat shadow-none border-0" id="exampleFormControlTextarea1" rows="3" #reply_text_input></textarea>
        </div>
        <div class="w-25">
            <button class="bg-gradient btn btn-warning h-100 w-100" (click)="send_reply(reply_text_input);">ارسال</button>
        </div>
    </div>

</div>